import $ from 'jquery'
import AjaxRequest from "../modules/ajax-request";

class NewsletterUnsubscribe {
    constructor() {
        this.form = $('[name="newsletter_unsubscription"]');

        this.bindEvents(this);
    }

    bindEvents(selfInstance) {
        $(this.form).on("submit", function (event) {
            selfInstance.submitForm(event, this);
        });
    }

    submitForm(e, form) {
        e.preventDefault();

        var _this = $(form);

        var email = $.trim($("#newsletter_unsubscription_email", _this).val());

        var url = _this.attr("action");

        if (email.length > 0) {
            var ajaxRequest = new AjaxRequest({
                elementToAddLoading: '[data-type="unsubscribe-wrapper"]',
                successCallback: function (response) {
                    $('[data-type="message"]', _this)
                        .removeClass("is-success is-failure")
                        .addClass(response.class)
                        .text(response.message);
                }
            });

            ajaxRequest.makeCall(url, _this.serialize());
        }
    }
}

export default NewsletterUnsubscribe;